import { type Paypal } from '../../types/paypal';
import { type ValueOf } from '../../types/ValueOf';

type PayPalMethodsEligibility = Record<ValueOf<Paypal['FUNDING']>, boolean>;

export const getPayPalMethodsEligibility = (): PayPalMethodsEligibility => {
  return Object.fromEntries(
    (
      [
        window.paypal.FUNDING.PAYPAL,
        window.paypal.FUNDING.PAYLATER,
        window.paypal.FUNDING.VENMO,
        window.paypal.FUNDING.CREDIT,
      ] as const
    ).map((fundingSource) => {
      return [fundingSource, window.paypal.Buttons({ fundingSource }).isEligible()];
    }),
  ) as PayPalMethodsEligibility;
};
